export const VIEW_KIND_TABLE = 'TABLE';
export const VIEW_KIND_BOARD = 'BOARD';
export const VIEW_KIND_MATRIX = 'MATRIX';
export const VIEW_KIND_TIMELINE = 'TIMELINE';
export const VIEW_KIND_SECTION = 'SECTION';
// legacy view kind, unused
export const VIEW_KIND_TWOXTWO = 'TWOXTWO';

export const PROPERTY_LOADING_STATE = {
	LOADING: 'LOADING',
	LOADED: 'LOADED',
	ERROR: 'ERROR',
} as const;
